<modal-primecap>
  <div content>
    Por uma questão de segurança, confirme que <strong>{{ nomeInvestidor }}</strong> é o investidor(a) para quem esse investimento será lançado.
    <form [formGroup]="form"class="needs-validation">
      <div class="group-input">
        <input
        formControlName="investidor"
        placeholder="Digite o nome do investidor"
        required
        id="validationCustom01"
        >
      </div>
      <div class="invalid" *ngIf="!form.get('investidor')?.errors?.investidorConfirmado &&
      form.get('investidor')?.touched">
        Investidor não confirmado
      </div>
      <div class="valid" *ngIf="form.get('investidor')?.errors?.investidorConfirmado">
        Investidor confirmado
      </div>
      <div class="check-group mt-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="termoServico" type="checkbox" value="" id="flexCheckDefault">
          <label class="form-check-label" for="flexCheckDefault">
            O(A) investidor(a) leu e concorda com os
            <a [href]="termosServico" target="_blank"><strong>Termos de Serviço</strong></a>
          </label>
        </div>
        <div class="form-check ">
          <input class="form-check-input" formControlName="avisoRiscos" type="checkbox" value="" id="flexCheckChecked" checked>
          <label class="form-check-label" for="flexCheckChecked">
            O(A) investidor(a) está ciente do
            <a [href]="avisoRiscos" target="_blank"><strong> Aviso de Riscos </strong></a>
          </label>
        </div>
      </div>
    </form>
  </div>
  <button-primecap buttonClass="terciario-button-g" label="Cancelar" [mat-dialog-close]="true" cancel-button></button-primecap>
  <button-primecap buttonClass="primario-button-g" label="Confirmar Investimento" [mat-dialog-close]="false" [disabled]="validaForm()" (clickButton)="enviarPush()" confirm-button></button-primecap>

</modal-primecap>
